import { NotFoundError } from '@cian/peperrors/shared';
import { uniqWith } from 'ramda';

import { loadYMapsApi } from '../../../packages/YandexMaps/browser';
import { IApplicationContext } from '../../types/applicationContext';
import { IAddressSuggest, TResultSuggestion } from '../../types/suggest';

const BOUNDED_BY: [[number, number], [number, number]] = [
  [0, 0],
  [0, 0],
];

export async function getSuggestions(context: IApplicationContext, query: string): Promise<TResultSuggestion[] | null> {
  const { logger, config } = context;
  const apiKey = config.getStrict<string>('audience.YandexApiKey');

  try {
    const queryWithoutMotherland = query.trim().replace(/([, ]*Россия$|^Россия[, ]*)/gi, '');

    const yandexSuggestionsRequest = loadYMapsApi(apiKey, ['suggest'])
      .then(ymaps => ymaps.suggest(`Россия, ${queryWithoutMotherland}`, { boundedBy: BOUNDED_BY }))
      .catch(error => {
        logger.error('Failed to get yandex suggestions', error);

        return null;
      });

    const yandexSuggestionsData = await yandexSuggestionsRequest;

    if (!yandexSuggestionsData) {
      throw new NotFoundError({
        domain: 'services.getSuggestions',
        message: 'Failed to get any suggestions',
      });
    }

    const suggestions: TResultSuggestion[] = [];
    if (yandexSuggestionsData && yandexSuggestionsData.length > 0) {
      const modifiedYandexSuggestionsData = yandexSuggestionsData.map(removeMotherland) as IAddressSuggest[];
      const uniqYandexSuggestionsData = uniqWith((a, b) => a.value === b.value, modifiedYandexSuggestionsData);
      suggestions.push(...uniqYandexSuggestionsData);
    }

    return suggestions;
  } catch (error) {
    logger.error(error);

    return null;
  }
}

function removeMotherland<T>(item: YMaps.ISuggestResult<T>): YMaps.ISuggestResult<T> {
  return {
    ...item,
    displayName: item.displayName.replace(/, Россия$/, ''),
  };
}
